import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export default function filterByDate(event, sDate, eDate) {
  const eventRange = moment.range(moment(event.START_DATE), moment(event.END_DATE));
  const queryRange = moment.range(moment(sDate), moment(eDate));

  return queryRange.overlaps(eventRange);
}



// WEBPACK FOOTER //
// ./src/services/filters/filterByDate.js